<template>
    <div id="salvamentoAutomatico" v-on:mouseover="formatarHora">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <span v-on="on" v-html="mensagem"></span>
            </template>
            <span>Salvo {{dataAtualizada}} atrás</span>
        </v-tooltip>
    </div>
</template>

<script>
import moment from 'moment'
import {mapState} from 'vuex'

export default {
    name: 'SalvamentoAutomatico',
    data() {
        return {
            dataAtualizada: null
        }
    },
    computed: {
        ...mapState(['salvamentoAutomatico']),
        mensagem() {
            if (this.salvamentoAutomatico.salvando) {
                return this.mensagens.SALVANDO
            }
            if (!this.salvamentoAutomatico.salvando && this.salvamentoAutomatico.dataUltimoSalvamento && window.innerWidth > 720) {
                return this.mensagens.SALVO_AUTOMATICO
            }
            if (!this.salvamentoAutomatico.salvando && this.salvamentoAutomatico.dataUltimoSalvamento && window.innerWidth <= 720) {
                return this.mensagens.SALVO_AUTOMATICO_MOBILE
            }
            return ''
        }
    },
    methods: {
        formatarHora() {
            const end = moment(this.salvamentoAutomatico.dataUltimoSalvamento)
            const duration = moment.duration(end.diff(moment()))
            const data = duration.humanize(true)
            if (data === 'há segundos') {
                this.dataAtualizada = 'segundos'
            } else {
                this.dataAtualizada = data
            }
        }
    }
}
</script>

<style scoped lang="stylus">

</style>